import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-intro-text-modern',
  templateUrl: './intro-text-modern.component.html',
  styleUrls: ['./intro-text-modern.component.css']
})
export class IntroTextModernComponent implements OnInit {


  constructor() { }

  ngOnInit() {
  }

    downloadFiles(): void {
    const files = [
      '/assets/csv/crest_compounds.csv',
      '/assets/csv/crest_intermediate_compounds.csv'
    ];

    files.forEach((url) => {
      const a = document.createElement('a');
      a.href = url;

      a.download = url.split('/').pop() || 'download';
      // required for Firefox
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  }
  
}
